module.exports = __webpack_public_path__ + "img/plus2.4b5b6820.svg";